import { differenceInCalendarDays, parseISO } from "date-fns";

import { formatDate } from "simplydo/core/dates";
import { i18n } from "simplydo/core/i18n";
import type { OpenAPI } from "simplydo/interfaces";

import { type ChangeFields, type EditChange, describeValue } from "../changes";

/** Everything the content tab of a calendar saves. */
export const calendarFields: ChangeFields<
  Pick<OpenAPI.PUT<"/calendars/{calendar_id}">["requestBody"], "title">
> = { title: { kind: "text", label: "changes.calendar.title" } };

/** Describes moving every event of a calendar to a new reference date. */
export function describeCalendarShift(
  referenceStartYmd: string,
  proposedStartYmd: string,
): EditChange[] {
  const days = differenceInCalendarDays(
    parseISO(proposedStartYmd),
    parseISO(referenceStartYmd),
  );
  if (!days) return [];
  return [
    {
      text: describeValue(
        {
          kind: "choice",
          format: (ymd: string) => formatDate(parseISO(ymd), "d MMM yyyy"),
        },
        i18n.t("changes.calendar.shift.startDate"),
        referenceStartYmd,
        proposedStartYmd,
      ),
    },
    {
      text: i18n.t(`changes.calendar.shift.${days > 0 ? "forward" : "back"}`, {
        count: Math.abs(days),
      }),
    },
  ];
}
